import {SignUpConfirm} from 'domain/usecases';
import {RemoteSignUpConfirm} from 'data/usecases';
import {makeBFFApiUrl} from 'main/factories/http';
import {makeAuthorizeHttpClientDecorator} from 'main/factories/decorators';
import {EntryFlowEndPoints} from 'main/factories/usecases/endpoints';

export const makeSignUpConfirm = (): SignUpConfirm =>
	new RemoteSignUpConfirm(
		makeBFFApiUrl(EntryFlowEndPoints.signUpConfirm),
		makeAuthorizeHttpClientDecorator(),
	);
